import React, { Fragment } from 'react'
import Card from 'components/Card/Card.jsx'
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'

import Typography from '@material-ui/core/Typography'
import { titleCase, ymd } from '../utility/utility'

import classNames from 'classnames'
import isEmpty from 'lodash/isEmpty'
import upperCase from 'upper-case'
// display signer component
const signerStyles = {
  card: {
    width: '100%',
    height: 100
  },
  cardBorderNormal: {
    border: '1px solid black'
  },
  cardBorderError: {
    border: '2px solid red'
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)'
  },
  position: {
    marginLeft: '3px',
    fontSize: 10,
    color: 'textSecondary'
  },
  name: {
    fontSize: 18,
    color: 'blue'
  },
  pos: {
    marginBottom: 12
  },
  content: {
    marginLeft: '3px'
  },
  base: {
    fontFamily: '"Arizonia", Helvetica, sans-serif', //
    textShadow: '4px 4px 0px rgba(0,0,0,0.1)'
  },
  signiture: {
    paddingLeft: '5px',
    fontSize: '18px',
    fontStyle: 'oblique',
    fontWeight: 'bold'
  },
  date: {
    paddingRight: '5px',
    // marginLeft: 'auto', //在只有一个p 的时候，这个工作的很好
    float: 'right',
    fontSize: '16px',
    fontStyle: 'oblique',
    fontWeight: 'normal'
  },
  approve: {
    color: '#40ab0c'
  },
  reject: {
    color: '#f00'
  },
  action: {
    fontFamily: 'Robot', //
    marginLeft: '5px',
    fintSize: '16px',
    color: '$222222'
  }
}
const SignerTemplate = props => {
  const {
    classes,
    signer: { id, fullName, signedOn, action, role } //, chineseName, error, level,position,details
  } = props
  // console.log(props)
  const cardClass = classNames({
    [classes.card]: true,
    [classes.cardBorderNormal]: !isEmpty(id),
    [classes.cardBorderError]: isEmpty(id)
  })
  const signitureClass = classNames({
    [classes.signiture]: true,
    [classes.base]: true,
    [classes.approve]: action === 'approve',
    [classes.reject]: action === 'reject'
  })
  const dateClass = classNames({
    [classes.date]: true,
    [classes.base]: true,
    [classes.approve]: action === 'approve',
    [classes.reject]: action === 'reject'
  })
  const actionClass = classNames({
    [classes.action]: true,
    [classes.approve]: action === 'approve',
    [classes.reject]: action === 'reject'
  })
  // console.log(this.props)
  return (
    <Card className={cardClass} raised>
      <div className={classes.position}>{role ? role : 'Staff'}</div>
      <Typography variant='body2' className={classes.content}>
        {fullName ? titleCase(fullName) : 'No available signer is found!'}
      </Typography>
      {action ? (
        <Fragment>
          <p className={signitureClass}>{titleCase(fullName)}</p>
          <p>
            <span className={actionClass}>{upperCase(action === 'approve' ? 'approved' : 'rejected')}</span>
            <span className={dateClass}>{ymd(signedOn)}</span>
          </p>
        </Fragment>
      ) : (
        ''
      )}
    </Card>
  )
}

export default withStyles(signerStyles)(SignerTemplate)
